import { render, staticRenderFns } from "./ShelfSkewPicker.vue?vue&type=template&id=bdf7f40e&scoped=true"
import script from "./ShelfSkewPicker.vue?vue&type=script&lang=js"
export * from "./ShelfSkewPicker.vue?vue&type=script&lang=js"
import style0 from "./ShelfSkewPicker.vue?vue&type=style&index=0&id=bdf7f40e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf7f40e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdf7f40e')) {
      api.createRecord('bdf7f40e', component.options)
    } else {
      api.reload('bdf7f40e', component.options)
    }
    module.hot.accept("./ShelfSkewPicker.vue?vue&type=template&id=bdf7f40e&scoped=true", function () {
      api.rerender('bdf7f40e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/display-builder/ShelfSkewPicker.vue"
export default component.exports